import { Component, Input, OnInit } from '@angular/core';
import { ResponsiveService } from '@frk/eds-components';
import { BaseTableResponsiveComponent } from '@shared/table/base-table-responsive.component';
import { FundId, HighLowNavData } from '@types';

@Component({
  selector: 'ft-nav-high-low',
  templateUrl: './nav-high-low.component.html',
  styleUrls: ['./nav-high-low.component.scss'],
})
export class NavHighLowComponent
  extends BaseTableResponsiveComponent
  implements OnInit {
  @Input() navAsOfDate: string;
  @Input() highLowNavTableData: HighLowNavData[];
  @Input() fundId: FundId;

  constructor(protected responsiveService: ResponsiveService) {
    super(responsiveService);
  }
}
